import * as dataTools from '../services/data_tools';

export default {
  namespace: 'dataTools',
  state: {
    trackingData: {},
  },
  effects: {
    *getTrackingMemberList({ payload: { values }, callback }, { call, put }) {
      const response = yield call(dataTools.getTrackingMemberList, values);
      yield put({
        type: 'save',
        payload: {
          trackingData: response.data,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    *getTemplateMemberList({ payload: { values }, callback }, { call, put }) {
      const response = yield call(dataTools.getTemplateMemberList, values);
      yield put({
        type: 'save',
        payload: {
          trackingData: response.data,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    *exportTrackingMember({ payload: { values }, callback }, { call, put }) {
      const response = yield call(dataTools.exportTrackingMember, values);
      yield put({
        type: 'save',
        payload: {},
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    *exportTemplateMember({ payload: { values }, callback }, { call, put }) {
      const response = yield call(dataTools.exportTemplateMember, values);
      yield put({
        type: 'save',
        payload: {},
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
  },
  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },
};
